;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "XtMGRu7oTy"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="XtMGRu7oTy"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/8fMdP4lzpsBAXocC/content/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "2awmQkRKcD"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  var _this = jQuery(this),
      _dom  = _this.find('.lh-counter-section'),
      counter = _this.find('.lh-counter-number');
  function numberWithCommas(num , separator) {
    if(!separator) return num;
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }
  let regexExt    = /([^\d]+)$/g;
  let regexFText  = /^([^\d]+)/g;
  function getTextInNumber(num, regex){
    f = regex.exec(num.toString());
    return f ? f[0] : ''
  }
  function getSeparatorNumber(num){
    num = num.toString().replace(regexExt,'').replace(regexFText,'');
    separator = /([^\d]+)/g.exec(num.toString());
    return separator ? separator[0] : '';
  }
  function getNum(num){
    num = num.toString().replace(/([^\d])/g,'');
    num = parseInt(num);
    return num ? num : 0;
  }
  function startCounter(){
    _dom.addClass('lh-init');
    counter.each(function() {
    var $this     = $(this),
        num       = $this.attr('data-number'),
        countTo   = getNum(num),
        exts      = getTextInNumber(num, regexExt),
        nExt      = exts.slice(0, exts.length - 1),
        ext       = exts.slice(-1),
        fText     = getTextInNumber(num, regexFText),
        separator = getSeparatorNumber(num);
    if(countTo < 1) return;
    $({ countNum: 0}).animate({
      countNum: countTo
      },
      {
        duration: parseFloat(section.settings.duration) * 1000,
        easing:'linear',
        step: function() {
          $this.text(fText + numberWithCommas(Math.floor(this.countNum), separator) + nExt + ((ext == '+') ? '' : ext));
        },
        complete: function() {
          $this.text(fText + numberWithCommas(Math.floor(this.countNum), separator) + nExt + ext);
        }

      });
    });
  }
  function isAnyPartOfElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);
    const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
    const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

    return (vertInView && horInView);
  }
  var time ;
  $(window).on('scroll resize',function(){
    if(time) clearTimeout(time);
    time = setTimeout(function(){
      if(!_dom.hasClass('lh-init')){
         isAnyPartOfElementInViewport(counter[0]) && startCounter();
      }
    },150);

  }).trigger('scroll');
 };						cb.bind($('section[data-section-id="2awmQkRKcD"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="2awmQkRKcD"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/8fMdP4lzpsBAXocC/counter/",						settings: {"duration":1}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "IJdAMQiWlD"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="IJdAMQiWlD"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/8fMdP4lzpsBAXocC/our-team/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');